import { Form, Input, Select, message } from "antd";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AccountService from "../../../../../Services/AccountService";
import UserService from "../../../../../Services/UserService";
import ClinicService from "../../../../../Services/ClinicService";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { useDispatch, useSelector } from "react-redux";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";

function RpmDetails({
  handleCancel,
  handleNext,
  handlePrevious,
  currPageView,
  isRpmEnabled
}, ref) {
  const [usersList, setUsersList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [clinicList, setClinicList] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const history = useHistory();
  const formRef = useRef();
  const dispatch = useDispatch();
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients
  );
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (selectedEditPatient && !selectedAcc && !selectedClinic) {
      if (selectedEditPatient.hospitalId) {
        setSelectedAcc({ account_Id: selectedEditPatient.hospitalId });
      }
      if (selectedEditPatient.hospitalId && selectedEditPatient.locationId) {
        setSelectedClinic({
          account_Id: selectedEditPatient.hospitalId,
          clinic_Id: selectedEditPatient.locationId,
        });
        if (selectedEditPatient.providerCode) {
          setSelectedDoc({
            account_Id: selectedClinic?.account_Id,
            clinic_Id: selectedClinic?.clinic_Id,
            userId: selectedEditPatient?.providerCode,
          });
        }
      }
      formRef.current?.setFieldsValue({
        hospitalId: selectedEditPatient.hospitalId,
        locationId: selectedEditPatient.locationId,
        userId: selectedEditPatient.providerCode,
        uhId: selectedEditPatient.uhId,
      });
    }
  }, [selectedEditPatient]);

  const collectValues = () => {
    if (!formRef.current) return;
    const { hospitalId, locationId, userId, uhId } =
      formRef.current.getFieldsValue();
    if (!hospitalId && !locationId && !userId) return;

    if (selectedEditPatient) {
      const isHospitalChanged = selectedEditPatient.hospitalId !== hospitalId;
      const isLocationChanged = selectedEditPatient.locationId !== locationId;
      const isProviderChanged = selectedEditPatient.providerCode !== userId;

      const payload = {
        ...(selectedEditPatient ? selectedEditPatient : {}),
        ...registrationPayload,
        ...(isHospitalChanged && {
          hospitalId,
          hospitalName: selectedAcc?.account_Name,
        }),
        ...(isLocationChanged && {
          locationId,
          locationName: selectedClinic?.clinic_Name,
        }),
        ...(isProviderChanged && {
          providerCode: userId,
          providerName: selectedDoc ? `${selectedDoc?.firstName} ${selectedDoc?.lastName}` : registrationPayload?.providerName,
        }),
        ...(uhId && { uhId }),
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      };

      dispatch(handleSetPatientRegistrationPayload(payload));
    } else {
      const payload = {
        ...registrationPayload,
        ...(hospitalId && { hospitalId, hospitalName: selectedAcc?.account_Name }),
        ...(locationId && { locationId, locationName: selectedClinic?.clinic_Name }),
        ...(userId && { providerCode: userId, providerName: selectedDoc ? `${selectedDoc?.firstName} ${selectedDoc?.lastName}` : registrationPayload?.providerName }),
        ...(uhId && { uhId }),
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      };

      dispatch(handleSetPatientRegistrationPayload(payload));
    }
  };

  useImperativeHandle(ref, () => ({
    collectValues: collectValues
  }));


  useEffect(() => {
    if (!loggedUser) {
      return history.push("/");
    }
    getAccountList();
    fetchClinicList();
    getUsersList();
  }, []);

  const getAccountList = async () => {
    let payload = {
      account_Id: loggedUser.user.account_Id,
      accountRoleType: "clinic",
    };

    try {
      const response = await AccountService.AccountList(payload);
      setAccountList(response.data);
      setSelectedAcc(response?.data[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const getUsersList = async () => {
    const userPayload = { pageNo: "1" };
    userPayload.account_Id = loggedUser.user.account_Id;
    userPayload.clinic_Id = loggedUser.user.clinic_Id;
    try {
      const response = await UserService.getUser(userPayload);
      setUsersList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectAcc = (value) => {
    if (value) {
      const selected = accountList.find(
        (clinic) => clinic.account_Id === value
      );
      setSelectedAcc(selected);
    } else {
      setSelectedAcc(null);
    }
  };

  const handleSelectClinic = (value) => {
    if (value) {
      const selected = clinicList.find((clinic) => clinic.clinic_Id === value);
      setSelectedClinic(selected);
    } else {
      setSelectedClinic(null);
    }
  };

  const handleClinicSearch = async (label) => {
    if (label && label.length >= 2) {
      const payload = {
        clinic_Name: label,
        account_Id: loggedUser.user.account_Id,
      };
      fetchClinicList(payload);
    } else {
      fetchClinicList({ account_Id: loggedUser.user.account_Id });
    }
  };

  const fetchClinicList = async (filterVal) => {
    const payload = {
      account_Id: loggedUser.user.account_Id,
      status: 1,
    };

    let finalPayload;
    if (filterVal) {
      finalPayload = {
        ...payload,
        ...filterVal,
      };
    }

    try {
      const response = await ClinicService.getClinicList(
        filterVal ? finalPayload : payload
      );
      setClinicList(response.data);
      if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
        const userClinic = response.data.find(
          (item) => item.clinic_Id === loggedUser?.user?.clinic_Id
        );
        setSelectedClinic(userClinic);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleProviderDetailSave = () => {
    if (ref?.current?.collectValues) ref.current.collectValues();
    else collectValues();
    handleNext();
  };

  const handleDocChange = (value) => {
    setSelectedDoc(usersList.find((item) => item.userId === value));
  };

  return (
    <div>
      <Form
        disabled={!isRpmEnabled}
        className="w-full grid md:grid-cols-3 grid-cols-1 md:justify-center md:items-center"
        ref={formRef}
      >
        <div className="relative mt-3 md:w-4/5 w-full">
          <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
            Hospital/Medical Practice <span className="text-red-500">*</span>
          </span>

          <Form.Item name="hospitalId" className="mt-1">
            <Select
              placeholder="Select Hospital"
              className="rounded-md h-10"
              showSearch
              allowClear
              onChange={handleSelectAcc}
              options={accountList?.map((acc, idx) => ({
                label: acc.account_Name,
                value: acc.account_Id,
                key: idx,
              }))}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              dropdownStyle={{ width: "15rem" }}
            />
          </Form.Item>
        </div>

        <div className="relative mt-3 md:w-4/5 w-full">
          <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
            Location <span className="text-red-500">*</span>
          </span>

          <Form.Item name="locationId" className="mt-1">
            <Select
              placeholder="Branch"
              className="rounded-md h-10"
              onChange={handleSelectClinic}
              onSearch={handleClinicSearch}
              showSearch
              allowClear
              options={clinicList.map((clinic, idx) => ({
                label: clinic.clinic_Name,
                value: clinic.clinic_Id,
                key: idx,
              }))}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </div>

        <div className="relative mt-3 md:w-4/5 w-full">
          <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
            Provider <span className="text-red-500">*</span>
          </span>

          <Form.Item name="userId" className="mt-1">
            <Select
              placeholder="Select Doctor"
              className="rounded-md h-10"
              showSearch
              allowClear
              onChange={handleDocChange}
              options={usersList?.map((user, idx) => ({
                label: `${user.firstName} ${user.lastName}`,
                value: user.userId,
                key: idx,
              }))}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </div>

        <div className="relative mt-3 md:w-4/5 w-full">
          <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
            UHID
          </span>

          <Form.Item name="uhId" className="mt-1">
            <Input
              placeholder="Enter uhid"
              className="w-full h-10 outline-none border-2 rounded-md px-2"
            />
          </Form.Item>
        </div>
      </Form>

      <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
        <button
          disabled={currPageView === 1}
          className={`${currPageView > 1 ? "block" : "hidden"
            } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
          onClick={handlePrevious}
        >
          Previous
        </button>
        <button
          className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-white rounded-md border  border-brand-primaryColor font-semibold custom-button-shadow"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
          onClick={handleProviderDetailSave}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default forwardRef(RpmDetails);
